import { render, staticRenderFns } from "./SamIconList.vue?vue&type=template&id=52e7a02e&scoped=true&"
import script from "./SamIconList.vue?vue&type=script&lang=js&"
export * from "./SamIconList.vue?vue&type=script&lang=js&"
import style0 from "./SamIconList.vue?vue&type=style&index=0&id=52e7a02e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e7a02e",
  null
  
)

export default component.exports